import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconCloseLarge = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 48,
	height: 48,
	fill: "none",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#111",
		fillRule: "evenodd",
		d: "m24 22.6 5.6-5.6 1.4 1.4-5.6 5.6 5.6 5.6-1.4 1.4-5.6-5.6-5.6 5.6-1.4-1.4 5.6-5.6-5.6-5.6 1.4-1.4 5.6 5.6z",
		clipRule: "evenodd"
	})
});
export default SvgIconCloseLarge;
